import { render, staticRenderFns } from "./BodyCalepinage.vue?vue&type=template&id=9d7eaa4a&scoped=true"
import script from "./BodyCalepinage.vue?vue&type=script&lang=js"
export * from "./BodyCalepinage.vue?vue&type=script&lang=js"
import style0 from "./BodyCalepinage.vue?vue&type=style&index=0&id=9d7eaa4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7eaa4a",
  null
  
)

export default component.exports